import React from 'react';
import { Container, Flex, Loader } from '@mantine/core';
import styles from '../ModelDetail.module.scss';

export const LoadingState: React.FC = () => {
  return (
    <Container size="xl" className={styles.container}>
      <Flex justify="center" align="center" style={{ height: '300px' }}>
        <Loader size="lg" />
      </Flex>
    </Container>
  );
};
